/**
 * Parâmetros do rastreamento de tempo ativo de uso da plataforma.
 *
 * O rastreamento é invisível para o aluno: não existe nenhuma UI associada a
 * estes valores. Eles alimentam o KPI de engajamento exibido no admin.
 */

/** Tempo sem interação a partir do qual a contagem é pausada. */
export const IDLE_TIMEOUT_SECONDS = 5 * 60

/**
 * Intervalo de tempo acumulado entre envios para a api.
 *
 * Deve espelhar UsageTimes::IngestService::FLUSH_INTERVAL_SECONDS na api, que
 * deriva dele o teto por requisição (2x este valor).
 */
export const FLUSH_INTERVAL_SECONDS = 60

/**
 * Máximo de segundos enviados numa única requisição.
 *
 * Espelha UsageTimes::IngestService::MAX_SECONDS_PER_FLUSH. O client respeita o
 * mesmo teto para que um acúmulo represado por falha de rede seja drenado em
 * várias requisições, em vez de ser truncado pelo clamp do servidor.
 */
export const MAX_SECONDS_PER_FLUSH = FLUSH_INTERVAL_SECONDS * 2

/** Frequência do tick que incrementa o acumulador. */
export const TICK_INTERVAL_MS = 1000

export const USAGE_TIME_ENDPOINT = '/user/usage_times'

/** Eventos que contam como interação do aluno com a aplicação. */
export const ACTIVITY_EVENTS = [
  'mousemove',
  'keydown',
  'scroll',
  'click',
  'touchstart'
] as const
